enum AccountRegistrationBehaviour {
        LinkEmailToAccount = 0,
        OnlyEmailReport = 1
}

export default AccountRegistrationBehaviour;
